import './style.less';
import { get } from 'lodash';


export default function($log, $scope, ProfileClass) {
  'ngInject';

  const vm = this;
  this.$onInit = activate;

  function activate() {
    $log.debug('Users readOnly controller activated');

    const slug = get(ProfileClass, 'profileComplete.company.preferences.slug', false);
    console.log(slug)
    $scope.url = slug ? `https://${slug}.lcvista.com` : 'https://lcvista.com';
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/readOnly/index.js